import { TProduct, TTimeSlot } from 'feature/appeals/type'
import { TSuggest } from 'feature/registration/types'
import { ModalConfirm } from 'feature/user/components'

import { ModalAddressEdit } from '../../ModalAddressEdit/ModalAddressEdit'
import { ModalEditProductParams } from '../../ModalEditProductParams/ModalEditProductParams'
import { ModalTimeSlotsEdit } from '../../ModalTimeSlotsEdit/ModalTimeSlotsEdit'
import { ModalWrap } from '../../ModalWrap/ModalWrap'
import { TModalsType } from '../OrderInformationBlock'

import style from './EditModalsList.module.scss'

type TEditModalsList = {
  location: TSuggest
  timeSlotTitle: string
  editableProduct: TProduct | null
  handleCloseManageModal: () => void
  checkIsModalOpen: (type: TModalsType) => boolean
  timeSlots: TTimeSlot[] | null
  deletedProduct: TProduct | null
  isDeleteButtonLoading: boolean | undefined
  handleProductDelete: () => void
}

// модальные окна для редактирования заяки
export const EditModalsList = ({
  checkIsModalOpen,
  deletedProduct,
  handleProductDelete,
  isDeleteButtonLoading,
  location,
  timeSlots,
  timeSlotTitle,
  editableProduct,
  handleCloseManageModal,
}: TEditModalsList) => {
  return (
    <>
      <ModalWrap
        isModalOpen={checkIsModalOpen('params')}
        onClose={handleCloseManageModal}
        tabletSmallSize
      >
        {editableProduct?.parameters && (
          <ModalEditProductParams
            onClose={handleCloseManageModal}
            product={editableProduct}
          />
        )}
      </ModalWrap>
      <ModalWrap
        isModalOpen={checkIsModalOpen('address')}
        onClose={handleCloseManageModal}
        tabletSmallSize
      >
        <ModalAddressEdit
          location={location}
          isModalOpen={checkIsModalOpen('address')}
          onClose={handleCloseManageModal}
        />
      </ModalWrap>
      {timeSlots && (
        <ModalWrap
          isModalOpen={checkIsModalOpen('time')}
          onClose={handleCloseManageModal}
          tabletSmallSize
        >
          <ModalTimeSlotsEdit
            timeSlotTitle={timeSlotTitle}
            userSelectedTimeSlots={timeSlots}
            onClose={handleCloseManageModal}
          />
        </ModalWrap>
      )}

      {deletedProduct && (
        <ModalConfirm
          modalText={`Вы действительно хотите удалить изделие “${deletedProduct.name}”?`}
          cancelText='Отменить'
          actionText='Да'
          isModalOpen={checkIsModalOpen('delete')}
          isButtonLoading={isDeleteButtonLoading}
          onCancel={handleCloseManageModal}
          onConfirm={handleProductDelete}
          className={style.deleteModal}
        />
      )}
    </>
  )
}
